/*
在main.js 添加
import SurveyDialogPlugin from "@/plugins/surveyDialog";
Vue.use(SurveyDialogPlugin);

使用:
this.$surveyDialog({
  modalVisible: true,
  openMode: "ADD", // ADD VIEW
  activityQuestionnaireProperty: "", // getActivityQuestionnaireProperty()
  activityQuestionnaireType: "", // getActivityQuestionnaireType()
  templateId: "", // externalId
  questionnaireId: "", // businessId
  showVerificationConfig: true,
  success: (data:{title,questionnaireId}) => {},
  templateSuccess: (data)=>{console.log("templateSuccess id:",data)},
})

<addSurveyDialog
    :modalVisible.sync="dialogVisiable"
    :openMode="addSurveyDialogOpenMode"
    @success="addSurveyModel"
    @templateSuccess="templateSuccess"
    :activityQuestionnaireProperty="activityQuestionnaireProperty"
    :activityQuestionnaireType="activityQuestionnaireType"
    :templateId="formRule.activityTaskRule.relationList[0].externalId"
    :questionnaireId="formRule.activityTaskRule.relationList[0].businessId"
    :showVerificationConfig="formRule.activityTaskRule.specialRuleJson.machineAuditRule && formRule.activityTaskRule.specialRuleJson.machineAuditRule.machineOpen && formRule.activityTaskRule.specialRuleJson.machineAuditRule.questionnaireVerificationSwitch"
  ></addSurveyDialog>
* */

import Vue from "vue";
import surveyDialog from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/components/questionnaireSet/addSurveyForActivityDialog.vue";

// 创建构造器
const SurveyDialogConstructor = Vue.extend(surveyDialog);

let instance = null;

const SurveyDialogPlugin = {
  install(Vue, options = { modalVisible: true }) {
    // 全局方法
    Vue.prototype.$surveyDialog = function (config = {}) {
      console.log("插件被调用，配置:", config);

      return new Promise((resolve, reject) => {
        console.log("开始创建弹窗实例");

        // 如果已有实例，先销毁
        if (instance) {
          console.log("发现已存在的实例，正在清理...");
          instance.$destroy();
          instance.$el.remove();
          instance = null;
        }

        // 创建新实例
        try {
          const propsData = {
            ...options,
            ...config,
          };
          instance = new SurveyDialogConstructor({
            propsData,
          });
          console.log("实例创建成功:", instance);

          instance.$on("close", () => {
            instance.modalVisible = false;
            reject();
          });
          instance.$on("cancel", () => {
            instance.modalVisible = false;
            reject();
          });
        } catch (error) {
          console.error("创建实例失败:", error);
          reject(error);
          return;
        }

        // 挂载实例
        instance.$mount();
        console.log("实例挂载完成，添加到DOM");
        document.body.appendChild(instance.$el);

        // 添加overlay类
        instance.$el.classList.add("survey-dialog-overlay");

        // 等待组件渲染完成
        Vue.nextTick(() => {
          console.log("DOM已更新，调用open方法");

          // 检查实例是否存在open方法
          if (typeof instance.open !== "function") {
            console.error("实例没有open方法");
            reject(new Error("组件缺少open方法"));
            cleanup();
            return;
          }

          // 打开弹窗
          instance
            .open()
            .then((value) => {
              console.log("open方法成功:", value);
              instance.modalVisible = false;
              resolve(value);
            })
            .catch((error) => {
              console.error("open方法失败:", error);
              instance.modalVisible = false;
              reject(error);
            })
            .finally(() => {
              // 清理逻辑可以放在组件的关闭事件中
            });
        });
      });
    };

    // 清理函数
    function cleanup() {
      if (instance) {
        setTimeout(() => {
          if (instance && instance.$el && instance.$el.parentNode) {
            console.log("清理实例");
            instance.$destroy();
            instance.$el.remove();
            instance = null;
          }
        }, 300);
      }
    }

    // 注册全局组件（可选）
    Vue.component("surveyDialog", surveyDialog);
  },
};

if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(SurveyDialogPlugin);
}

export default SurveyDialogPlugin;
